import { z } from "zod"

export const GROUPINGS = [
  "issued_by",
  "regulator",
  "manufacturer",
  "ata_chapter",
] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const GROUPING_LABELS: Record<Grouping, string> = {
  issued_by: "Issued by",
  regulator: "Source feed",
  manufacturer: "Manufacturer",
  ata_chapter: "ATA chapter",
}
